import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import CustomDropdown from '@components/CustomDropdown';
import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';

import UploadKeyProduct from '@features/supplier/component/UploadKeyProduct';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { getAllSuppliersMaterials } from '@store/reducers';
import { fetchAllSuppliersMaterials } from '@store/supplier/action';

import { fetchBrands, fetchCategoryAndSubCategories, fetchDepartments } from '@services/commonService';
import { addSupplierProduct, updateSupplierProduct } from '@services/supplierOnboardingService';

const KeyProductGarments = ({ onClose, onSuccess, selectedProduct }) => {
	const [documentList, setDocumentList] = useState([]);
	const [categories, setCategories] = useState([]);
	const [brands, setBrands] = useState([]);
	const [departments, setDepartments] = useState([]);
	const { id } = useParams();
	const dispatch = useDispatch();
	const isLoading = useSelector((store) => store.loaderStore);
	let allFabrics = useSelector(getAllSuppliersMaterials);
	const [selectedFabric, setSelectedFabric] = useState({});
	const [selectedCategory, setSelectedCategory] = useState({});
	const [selectedBrand, setSelectedBrand] = useState({});
	const [selectedMarket, setSelectedMarket] = useState({});
	allFabrics = allFabrics?.data?.map((item) => {
		return {
			id: item.materialId,
			value: item.name
		};
	});
	const [searchFabric, setSearchFabric] = useState('');
	const [inputData, setInputData] = useState({});
	const [errors, setErrors] = useState({});

	useEffect(() => {
		if (selectedProduct && selectedProduct?.featureImageId) {
			setDocumentList([
				{ id: selectedProduct.featureImageId, docUrl: selectedProduct.featureImageUrl }
			]);
			setSelectedCategory({
				value: selectedProduct.subCategory,
				id: selectedProduct.subCategoryId
			});
			setSelectedBrand({
				value: selectedProduct.brandName,
				id: selectedProduct.brandId
			});
			setSelectedMarket({
				value: selectedProduct.productGroup,
				id: selectedProduct.productGroupId
			});
			setSelectedFabric({
				value: selectedProduct.fabricName,
				id: selectedProduct.materialId
			});
			setInputData((prev) => ({
				...prev,
				price: selectedProduct.price,
				season: selectedProduct.season
			}));
		}
	}, [selectedProduct]);

	const onFabricSearch = (value) => {
		setSearchFabric(value);
	};

	useEffect(() => {
		dispatch(fetchAllSuppliersMaterials(0, 20, 'FABRIC', 'id,desc', { search: searchFabric }));
	}, [searchFabric]);

	useEffect(() => {
		(async () => {
			const brandList = await fetchBrands();
			const departmentList = await fetchDepartments();
			const categoryList = await fetchCategoryAndSubCategories();
			setBrands(brandList?.map((item) => ({ id: item.id, value: item.name })));
			setDepartments(departmentList?.map((item) => ({ id: item.id, value: item.name })));

			let tmpCategories = [];
			for (let item of categoryList) {
				for (let subCategory of item.subCategoryResponseList) {
					tmpCategories.push({ id: subCategory.id, value: subCategory.name });
				}
			}
			setCategories(tmpCategories);
		})();
	}, []);

	const onItemClick = (item) => {
		if (item?.title === 'Category') {
			setSelectedCategory(item);
		}
		if (item?.title === 'Brand') {
			setSelectedBrand(item);
		}
		if (item?.title === 'Fabric') {
			setSelectedFabric(item);
		}
		if (item?.title === 'Market') {
			setSelectedMarket(item);
		}
	};

	const isValid = () => {
		let err = {};
		if (!selectedCategory?.id) {
			err['productCategoryError'] = 'Product category is required!';
		}
		setErrors(err);
		return Object.keys(err).length <= 0;
	};

	const onSave = async () => {
		if (isValid()) {
			try {
				dispatch(openLoader());
				let selectedImageList = documentList.map((item, i) => ({
					documentId: item.id,
					front: i === 0
				}));
				let postData = {
					documentDTOList: selectedImageList,
					productSubCategoryId: selectedCategory.id,
					name: selectedCategory.value,
					productGroupId: selectedMarket.id,
					brandId: selectedBrand.id,
					season: inputData.season,
					price: inputData.price,
					materialId: selectedFabric.id
				};
				if (selectedProduct?.id) {
					postData['productId'] = selectedProduct.id;
					await updateSupplierProduct(id, postData);
				} else {
					await addSupplierProduct(id, postData);
				}
				await onSuccess();
				dispatch(closeLoader());
			} catch {
				dispatch(closeLoader());
			}
		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setInputData((prev) => ({
			...prev,
			[name]: value
		}));
	};

	return (
		<ModalContainer className="products-upload-modal">
			<div className="common-popup">
				<ModalHeader title="Your Key Product (Garments)" onClose={onClose} />
				<div className="common-popup-body">
					<div className="row">
						<UploadKeyProduct
							product={selectedProduct}
							productId={selectedProduct.id}
							fieldName="garmentsUpload"
							setDocumentList={setDocumentList}
							documentList={documentList}
						/>
						<div className="col-md-6 pr-2">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Market</label>
									<CustomDropdown
										type="addItem"
										title={'Market'}
										isAddNew={false}
										onItemClick={onItemClick}
										items={departments}
										selectedItem={selectedMarket.value}
									/>
								</div>
							</div>
						</div>
						<div className="col-md-6 pr-2">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Product Category*</label>
									<CustomDropdown
										type="addItem"
										title={'Category'}
										isAddNew={false}
										onItemClick={onItemClick}
										items={categories}
										selectedItem={selectedCategory.value}
									/>
								</div>
								{errors?.productCategoryError && (
									<p className="error">{errors.productCategoryError}</p>
								)}
							</div>
						</div>
						<div className="col-md-6 pr-2">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Brand</label>
									<CustomDropdown
										type="addItem"
										title={'Brand'}
										isAddNew={false}
										onItemClick={onItemClick}
										items={brands}
										selectedItem={selectedBrand.value}
									/>
								</div>
							</div>
						</div>
						<div className="col-md-6 pr-2">
							<div className="form-group">
								<label htmlFor="collection">Season</label>
								<input
									type="text"
									value={inputData?.season || ''}
									name="season"
									onChange={handleChange}
								/>
							</div>
						</div>
						<div className="col-md-6 pr-2">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Fabric</label>
									<CustomDropdown
										type="addItem"
										title={'Fabric'}
										isAddNew={false}
										onItemClick={onItemClick}
										items={allFabrics}
										selectedItem={selectedFabric.value}
										onItemSearch={onFabricSearch}
										toolTipLength={20}
									/>
								</div>
							</div>
						</div>
						<div className="col-md-6 pr-2">
							<div className="form-group">
								<label htmlFor="collection">Price</label>
								<input
									type="text"
									value={inputData?.price || ''}
									name="price"
									onChange={handleChange}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onClose}>
							Cancel
						</button>
						<button disabled={isLoading} className="button size32 ml-2" onClick={() => onSave()}>
							Submit
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default KeyProductGarments;
